import { Tag, Flex } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import {
  selectPromptTemplateFilters,
  removePromptTemplateFilter,
} from '../../../../store/stylist/slice';

const ActiveFiltersBar = () => {
  const dispatch = useAppDispatch();
  const activeFilters = useAppSelector(selectPromptTemplateFilters);

  const handleRemoveFilter = (field: string, filterType: string) => {
    dispatch(removePromptTemplateFilter({ field, filterType }));
  };

  if (!activeFilters.length) return null;

  return (
    <div style={{ padding: '24px 0' }}>
      <Flex gap={8} wrap>
        {activeFilters.map(filter => (
          <Tag
            key={`${filter.field}-${filter.filterType}`}
            closable
            onClose={() => handleRemoveFilter(filter.field, filter.filterType)}
            style={{
              background: '#ffffff',
              border: '1px solid #E9ECEF',
              color: '#171717',
              borderRadius: 20,
              padding: '8px 12px',
              margin: 0,
            }}
          >
            {filter.value}
          </Tag>
        ))}
      </Flex>
    </div>
  );
};

export default ActiveFiltersBar;
